import { Spin } from 'antd';
import styled from 'styled-components';

export const CompanyDetailsWrapper = styled.div`
  background: ${p => p.theme.backgroundColor};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DetailsWrapper = styled.div`
  padding: 24px;
`;

export const Spinner = styled(Spin)`
  margin: auto;
`;
